import React from 'react';
import { Shield, Lock, Award } from 'lucide-react';

export const Trust = () => {
  const trustItems = [
    {
      icon: Shield,
      title: 'Datos seguros',
      description: 'Cumplimos con estándares de seguridad y protección de datos educativos.'
    },
    {
      icon: Lock,
      title: 'Privacidad garantizada',
      description: 'Tu información y la de tus estudiantes permanece privada y protegida.'
    },
    {
      icon: Award,
      title: 'Hecho para colegios',
      description: 'Diseñado específicamente para instituciones educativas colombianas.'
    }
  ];

  return (
    <section className="py-16 lg:py-20 bg-white border-y border-gray-100">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="sr-only">Seguridad y confianza</h2>
        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {trustItems.map((item, index) => {
            const Icon = item.icon;
            return (
              <div key={index} className="text-center">
                <div className="inline-flex items-center justify-center w-14 h-14 bg-blue-50 rounded-xl mb-4">
                  <Icon size={28} className="text-blue-600" strokeWidth={2} />
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-gray-600 text-sm">
                  {item.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
